import { NavLink, Route, useLocation } from "react-router-dom";
import "./header.scss";
import HeaderAdapter from "./header.adapter";
import { useState } from "react";
import { ENUM_PAGE } from "src/libraries/enums/pages";
import BreadCrumb from "src/libraries/components/breadcrumb/breadcrumb";
import AvatarMenu from "src/libraries/components/avatar/avatar";

function HeaderScreen() {
  return (
    <header className="tittlebar">
      <div className="navigating-titlebar">
        <Route path={ENUM_PAGE.HOME} exact>
          <p className="tittlebar-name">{"Trang chủ"}</p>
        </Route>
        <Route path={ENUM_PAGE.MERCHANT} exact>
          <p className="tittlebar-name">{"Tổ chức"}</p>
        </Route>
        <Route path={ENUM_PAGE.TRANSACTION} exact>
          <p className="tittlebar-name">{"Giao dịch"}</p>
        </Route>
        <Route path={ENUM_PAGE.BANK} exact>
          <p className="tittlebar-name">{"Tài khoản ngân hàng"}</p>
        </Route>
        <Route path={ENUM_PAGE.CHANNEL} exact>
          <p className="tittlebar-name">{"Kênh thanh toán"}</p>
        </Route>
      </div>

      <div className="profile-dropdown">
        <div className="notification-profile">
          <AvatarMenu
            username="John Doe"
            avatarUrl="https://img.tapimg.net/market/images/a4b370e90527c4d8dd8e2b7426f0f6c3.jpg?imageView2/0/h/270/format/jpg/interlace/1/ignore-error/1"
            style={{ width: "200px" }}
            menuItems={[
              {
                key: "Thanh toán",
                label: "Thanh toán",
                onClick: () => {},
                // icon: <UserOutlined />,
              },
            ]}
          />
        </div>
      </div>
    </header>
  );
}

export default HeaderScreen;
